<div>
    <input #questionInput placeholder="Question" (keyup)="onQuestionEnter(questionInput)">
    <input #scoreInput placeholder="Score" (keyup)="onScoreEnter(scoreInput)">
    <input #optionInput *ngFor="let option of options; let i = index;" placeholder="Option" (keyup)="onOptionKeyUp(i, optionInput)">
    <input #correctChoiceInput (keyup)="onCorrectChoiceEnter(correctChoiceInput)" *ngIf="options.length > 0" placeholder="Correct Choice Index">
    <button (click)="onAddOptionClick()">Add Option</button>
</div>